// Libs
import React from 'react';
import { Card as MuiCard, CardContent } from '@mui/material';

// Components
import CartCardMedia from './CartCardMedia';
import CartCardHeader from './CartCardHeader';
import CartCardDescription from './CartCardDescription';
import CartCardFooter from './CartCardFooter';
import SaveForLaterButton from './SaveForLaterButton';
import KitsProductQtyButtons from '../../../Kits/KitsProductQtyButtons/KitsProductQtyButtons';

// Hooks
import useCartCard from './useCartCard';

// Utils
import canRateProduct from '../../../../utils/canRateProduct';

const CartCard = ({
  product,
  reviewOrderPage,
  kitDetailsPage,
  placedOrder,
  addressesCount = 1,
  kit,
  nums,
  disabledCountBtn = false,
  onClearOverLimitInDB = () => {},
  onSaveOverLimitInDB = () => {},
  readOnly = false,
  KitQtyComponent = KitsProductQtyButtons,
  onDeleteKitProduct,
  kitItemOrderable,
  fromSharedKit = false,
}) => {
  const cartCard = useCartCard({
    product,
    reviewOrderPage,
    placedOrder,
    addressesCount,
    kit,
    kitItemOrderable,
    fromSharedKit,
    onClearOverLimitInDB,
    onSaveOverLimitInDB,
    readOnly,
  });

  const { owner, image_link: image } = product || {};
  const isRatable = canRateProduct(product);

  return (
    <MuiCard disabled={!image} className={cartCard.classes.root}>
      <CartCardMedia
        product={product}
        placedOrder={placedOrder}
        unavailableWatermark={cartCard.unavailableWatermark}
        onOpenModal={cartCard.onOpenModal}
        classes={cartCard.classes}
      />
      <CardContent className={cartCard.classes.content}>
        <CartCardHeader
          product={product}
          owner={owner}
          isMobileMode={cartCard.isMobileMode}
          isDesktopMode={cartCard.isDesktopMode}
          reviewOrderPage={reviewOrderPage}
          kitDetailsPage={kitDetailsPage}
          kit={kit}
          isRatable={isRatable}
          placedOrder={placedOrder}
          count={cartCard.count}
          saveForLater={cartCard.saveForLater}
          readOnly={readOnly}
          onDeleteKitProduct={onDeleteKitProduct}
          onDeleteClick={cartCard.onDeleteClick}
          removeProductFromKit={cartCard.removeProductFromKit}
          onDeleteProduct={cartCard.onDeleteProduct}
          pendingApproval={cartCard.pendingApproval}
          classes={cartCard.classes}
        />
        <CartCardDescription
          product={product}
          onOpenModal={cartCard.onOpenModal}
          reviewOrderPage={reviewOrderPage}
          isTabletMode={cartCard.isTabletMode}
          isMobileMode={cartCard.isMobileMode}
          placedOrder={placedOrder}
          pendingApproval={cartCard.pendingApproval}
          orderedProduct={cartCard.orderedProduct}
          isUnavailableForOrder={cartCard.isUnavailableForOrder}
          count={cartCard.count}
          addOneProduct={cartCard.addOneProduct}
          removeOneProduct={cartCard.removeOneProduct}
          setCount={cartCard.setCount}
          isOverLimitProduct={cartCard.isOverLimitProduct}
          kit={kit}
          nums={nums}
          unavailableLabel={cartCard.unavailableLabel}
          addressesCount={addressesCount}
          readOnly={readOnly}
          KitQtyComponent={KitQtyComponent}
          classes={cartCard.classes}
        />
        <CartCardFooter
          isTabletMode={cartCard.isTabletMode}
          isMobileMode={cartCard.isMobileMode}
          isDesktopMode={cartCard.isDesktopMode}
          placedOrder={placedOrder}
          kit={kit}
          isUnavailableForOrder={cartCard.isUnavailableForOrder}
          readOnly={readOnly}
          nums={nums}
          product={product}
          KitQtyComponent={KitQtyComponent}
          isOverLimitProduct={cartCard.isOverLimitProduct}
          addOneProduct={cartCard.addOneProduct}
          removeOneProduct={cartCard.removeOneProduct}
          setCount={cartCard.setCount}
          count={cartCard.count}
          disabledCountBtn={disabledCountBtn}
          addressesCount={addressesCount}
          pendingApproval={cartCard.pendingApproval}
          orderedQty={cartCard.orderedQty}
          totalOrderedQty={cartCard.totalOrderedQty}
          reviewOrderPage={reviewOrderPage}
          availableQuantity={product?.product_available_qty}
          unavailableLabel={cartCard.unavailableLabel}
          totalItemsHeader={cartCard.totalItemsHeader}
          totalItemsQty={cartCard.totalItemsQty}
          distributionUnitsQty={cartCard.distributionUnitsQty}
          classes={cartCard.classes}
          cx={cartCard.cx}
        />
      </CardContent>
      {!reviewOrderPage && !kit && !cartCard.isMobileMode && (
        <SaveForLaterButton
          product={product}
          count={cartCard.count}
          saveForLater={cartCard.saveForLater}
          className={cartCard.classes.saveLater}
        />
      )}
    </MuiCard>
  );
};

export default CartCard;
